import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef, input } from '@angular/core';

import { CardContent } from '@/shared/components/card-content/card-content';

/**
 * Container padrão com card de filtros na lateral esquerda e conteúdo à direita.
 * Usado para padronizar visualmente os painéis de Gestão (comissões e administrativa).
 */
@Component({
    selector: 'app-painel-lateral',
    standalone: true,
    imports: [CommonModule, CardContent],
    templateUrl: './painel-lateral.html',
    styleUrls: ['./painel-lateral.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PainelLateral {
    readonly tituloPainel = input.required<string>();
    readonly descricaoPainel = input<string>('');
    readonly iconePainel = input<string>('');
    readonly filtrosTemplate = input<TemplateRef<unknown> | null>(null);
    readonly conteudoTemplate = input.required<TemplateRef<unknown>>();
    readonly ocultarFiltros = input<boolean>(false);
}
